export default function () {
  return {
    events: {
      add: false
    },
    titlePage: '',
  }
}
